// extracted by mini-css-extract-plugin
export var amount = "styles-module--amount--12d47";
export var button = "styles-module--button--ef1b5";
export var container = "styles-module--container--a1380";
export var content = "styles-module--content--2a279";
export var description = "styles-module--description--f6581";
export var firstTitle = "styles-module--firstTitle--fdadd";
export var freebet = "styles-module--freebet--2a932";
export var image = "styles-module--image--ed195";
export var imageMobile = "styles-module--imageMobile--26832";
export var images = "styles-module--images--d5c4c";
export var ru = "styles-module--ru--86dc9";
export var rulesLink = "styles-module--rulesLink--e69a1";
export var secondTitle = "styles-module--secondTitle--33f49";
export var text = "styles-module--text--eb957";
export var title = "styles-module--title--ef6a8";